import React from "react";
import { HiOutlineMail } from "react-icons/hi";
import PageHeader from "../PageHeader";
import { useTranslation } from "react-i18next";

function WelcomeSignupConfirmation() {
  const { t } = useTranslation("utilityPages");

  return (
    <div className='min-h-screen bg-gray-50'>
      <PageHeader />
      <div className='flex justify-center items-center min-h-[calc(100vh-80px)] px-4'>
        <div className='bg-white shadow-md rounded-2xl p-8 max-w-xl w-full text-center'>
          <div className='flex justify-center mb-2'>
            <HiOutlineMail className='text-6xl text-cromboOrange' />
          </div>
          <h2 className='text-2xl font-bold mb-2'>{t("registrationThanks")}</h2>
          <p className='text-gray-600 text-base md:text-lg'>
            {t("registrationSubtext")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default WelcomeSignupConfirmation;
